
import LogoSalary from '@/assets/img/logo-salary.svg';
import { Panel, PanelContent, PanelFooter, PanelHeader } from '@/common/components/panel';
import { UserContext } from '@/common/contexts';
import { UserService } from '@/common/services';
import { Button, Input, Modal } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { SimpleAlert } from '@/common/components/simple-alert';

const LoginPanel = styled(Panel)`
    width: 400px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);


    input {
        margin-top: 10px;
    }
`;

export const Login: React.FunctionComponent = () => {
    const [ ci, setCI ] = React.useState('');
    const [ password, setPassword] = React.useState('');
    const [ CIError, setCIError ] = React.useState('');
    const [ passwordError, setPasswordError ] = React.useState('');

    const context = React.useContext(UserContext);

    if ( ! context) {
        return null;
    }

    const [ userStore, dispatch ] = context;

    const login = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (userStore.logingIn) {
            return;
        }

        if (ci.length !== 8) {
            setCIError('Cédula inválida');
            return;
        }
        if (password.length < 4) {
            setPasswordError('La contraseña debe tener al menos 4 caracteres');
            return;
        }

        try {
            dispatch({ type: 'AUTH::start' });
            const { user, token } = await UserService.login({ ci, password });

            dispatch({ type: 'AUTH::success', payload: { user, token }});
        } catch (error) {
            console.log('Error', error);
            if (error.response.status === 401) {
                Modal.error({
                    title: 'Error iniciando sesión',
                    content: 'El usuario y/o contraseña ingresados son inválidos',
                    okText: 'Intentar nuevamente'
                });
            }
            dispatch({ type: 'AUTH::error', payload: { error }});
        }
    };

    return (
        <section id='page-login'>
            <form onSubmit={ login }>
                <LoginPanel>
                    <PanelHeader justifyContent='center'>
                        <img width='190px'
                            alt='VITECH Sueldos'
                            style={{marginBottom: 40}} src={ LogoSalary } />
                    </PanelHeader>
                    <PanelContent padding='30px 30px 0 30px'>
                        <Input
                            onInput={ (event: any) => { setCI(event.target.value); setCIError(''); } }
                            placeholder='CI' />
                            
                            <SimpleAlert>{ CIError }</SimpleAlert>
                        <Input
                            onInput={ (event: any) => { setPassword(event.target.value); setPasswordError(''); } }
                            type='password'
                            placeholder='Contraseña' />
                            
                            <SimpleAlert>{ passwordError }</SimpleAlert>
                    </PanelContent>
                    <PanelFooter justifyContent='flex-end'>
                        <Button loading={ userStore.logingIn } htmlType='submit' type='primary'>
                            { userStore.logingIn ? 'Iniciando Sesión...' : 'Iniciar Sesión' }
                        </Button>
                    </PanelFooter>
                </LoginPanel>
            </form>
        </section>
    );
};
